import { DTO__image_asset } from '@shared/dto/+image/image_asset_base/DTO__image_asset';
import { FIELD__image_asset } from '@shared/dto/generation/graph_invoke/_fields/image/FIELD__image_asset';

// returns true if any image was initialized
export function FN_FIELD_IMAGE_ASSET__init_image(images_map_by_hash: Map<string, DTO__image_asset>, fields: FIELD__image_asset[]) {
  let out = false;

  for (let field of fields) {
    if (!images_map_by_hash.has(field.hash_sha256_content)) continue; //not loaded yet
    if (!field.asset.is_stub()) continue; //already initialized

    let image = images_map_by_hash.get_or_assert(field.hash_sha256_content);

    field.image__asset_use(image.clone());

    out = true;
  }

  return out;
}
